module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "sso-view row wrap",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    })
  }, [_c('v-fade-transition', [(_vm.mountDone) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "sso-card"
  }, [_c('img', {
    attrs: {
      "src": _vm.site_settings.styles.general.logo
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Signing in to Defense Exchange.")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.currentStatus))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce2ea71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SsoSigninView.vue
// module id = 1646
// module chunks = 38